module.exports = __webpack_public_path__ + "img/8.dcf70486.svg";